import styled from 'styled-components'

const ButtonText = styled.span`
  flex: 1 0;
  overflow: hidden;
  text-overflow: ellipsis;
`

export default ButtonText
